import { render, staticRenderFns } from "./driverList.vue?vue&type=template&id=dd2654c2&scoped=true"
import script from "./driverList.vue?vue&type=script&lang=js"
export * from "./driverList.vue?vue&type=script&lang=js"
import style0 from "./driverList.vue?vue&type=style&index=0&id=dd2654c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2654c2",
  null
  
)

export default component.exports